<template>
<v-main  v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :hidden="true" :page_title="'login_customer'" v-on:editContent="editContent"></header-common>
  <v-container class="text-left">
    <v-row>
      <v-col md="12" sm="12">
        <p>
          Connectez-vous à votre espace utilisateur pour pouvoir accéder aux informations relatives à vous.
        </p>
      </v-col>
      <v-col md="7">
        <v-scale-transition>
          <v-alert
            v-show="alert"
            color="red"
            type="error"
            
          >{{alertText}}</v-alert>
        </v-scale-transition>
          <v-text-field
          v-model="clientdata.email"
          label="Adresse Email"
          class="rounded-0"
          outlined
          ></v-text-field>
          <v-text-field
          v-model="clientdata.password"
          label="Mot de passe"
          type="password"
          class="rounded-0"
          outlined
          ></v-text-field>
          <v-row>
            <v-btn text :ripple="false">Vous ne pouvez plus acceder à votre compte?</v-btn>
            <v-spacer></v-spacer>
            <div>
            <v-hover v-slot:default="{ hover }">
              <v-btn @click="login" outlined :class="{ 'on-hover': hover }" large color="#1976d2" class="rounded-0 rounded-br-xl text-right"  style="border: 2px solid #1976d2; padding: 26px 15px; transition: all .1s ease-in-out; font-weight:700; margin-right:12px;">Connexion</v-btn>
            </v-hover>
            </div>
          </v-row> 
      </v-col>
      <v-col cols="12" offset-md="2" md="3">
        <div style="width:100%; height:fit-content; text-align:left; padding:0 30px; background: #003d90 url('https://demo.artureanec.com/html/transx/img/contact_background.png') bottom right no-repeat; background-size: 125px; padding-bottom:20px;clip-path: polygon(85% 0,100% 10%,100% 100%,0 100%,0 0);">
            <h2 style="color:white;font-weight:700; padding-top:20px;">Vous n'avez pas encore un compte?</h2>
            <v-btn dark outlined class="rounded-br-xl rounded-0" right style="margin-top:40px;">
            Rejoignez-nous!
            </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <footer-prime></footer-prime>
</v-main>
</template>

<script>
import headerCommon from "../commons/header"
import footerPrime from "../commons/footer"
import logo_light from "../../../assets/logo_light.png"
import logo_dark from "../../../assets/logo_dark.png"
import aboutImg from "../../../assets/section_1.jpg"
import aboutCart from "../../../assets/about_cart.png"

export default {
  name: 'customer-login',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      tabs: 'tab2',
      tab: null,
      clientdata: {
        email: '',
        password: ''
      },
      gerbable: false,
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      page_title: 'services',
      backgroundUrl: logo_light,
      aboutImage: aboutImg,
      aboutCart: aboutCart,
      alert: false,
      alertText: ''
    }),
    mounted() {
      if(this.$store.getters.isCustomerLoggedIn){
        this.$router.push({name: 'dashboardCustomer'})
      }
    },
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
        }else{
          this.backgroundUrl = logo_dark
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'login_customer'})
      },
      login(){
        this.alert = false
        if(this.$store.getters.isLoggedIn){
          this.alert = true
          this.alertText = "Vous êtes connecté en tant qu'administrateur, veuillez vous déconnecter pour pouvoir accèder à l'éspace client."
        }else{
          this.axios.post('../customer/login/check', this.clientdata).then((res) => {
            if(res.data.error === false){
                const token = res.data.token
                this.$store.dispatch('loginCustomer', { token })
                this.$router.push({name: 'dashboardCustomer'})
            }else{
              this.alert = true
              this.alertText = "Identifiant/Mot de passe incorrect, Veillez vérifier."
            }
            
          }).catch(e => {
            this.alert = true
            this.alertText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
          })
        }
      }
    },
    components: {
      headerCommon, footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.hide-customer-area {
  display: none !important;
}
.borderable-btn {
  border:2px solid #1976d2a1;
}
.single-service{
  position:relative;
}
.single-service .hoverable {
  position:absolute;
  width:100%;
  opacity: 0;
  transition: opacity .4s linear .2s;
}
.single-service:hover .hoverable{
  opacity: 1;
}
.quotes {
    background: url('https://i.imgur.com/yOZlJRU.png') no-repeat top left;
    background-size: 80px;
}
.quote-content {
    font-size: 16px;
    line-height: 25px;
    padding: 35px;
}
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.step {
    text-align:left;
    color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 0px;
  font-size: 18px;
  font-weight: 700;
}
.step-title {
    font-weight:700;
    font-size:18px;
    margin-bottom:15px;
    display: block;
}
.img-content {
    width:100%;
    height:550px;
    background-size:cover !important;
}
*{
  transition: all .3s ease-in;
}
.image-service{
    overflow: hidden;
}
.image-service:hover .img-content {
    transform: scale(1.2);
}
.service-position {
    font-size:36px;
    color: #41abff;
}
.description-service {
    position: absolute;
    bottom: 22px;
    left: 0;
    right: 0;
    width: 95%;
    padding: 0 30px 13px 30px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 1;
    font-size:20px;
    font-weight:700;
    color: white;
}
.text-service {
    position: absolute;
    top: 230px;
    left: 25px;
    color: #f3f6f5;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: 1;
}

* {
  font-family: 'Inter', sans-serif;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/customer/login.vue